/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-named-default */

import classNames from 'classnames';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import { components, default as ReactSelect } from 'react-select';
import AsyncSelect from 'react-select/async';
import useSortedOptions from '../../hooks/use-sorted-options';

const upIcon = 'fa fa-solid fa-caret-up faud';
const downIcon = 'fa fa-solid fa-caret-down faud';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <i className={props?.selectProps?.menuIsOpen ? upIcon : downIcon} />
  </components.DropdownIndicator>
);

const Select = ({
  label,
  formInput,
  name,
  required,
  className,
  placeholder,
  size,
  disabled,
  wrapperClassName,
  kind,
  rightContent,
  selectRef,
  options,
  sort,
  defaultOptions,
  loadOptions,
  isAsync,
  ...rest
}) => {
  const isMinimal = kind === 'minimal';
  const listOptions = useSortedOptions(options, sort);
  return (
    <div className={classNames('select-wrapper', { minimal: isMinimal }, size, wrapperClassName)}>
      {label && (
        <label htmlFor={name}>
          {label} <span>{required ? '*' : ''}</span>
        </label>
      )}
      {rightContent && <span className="input-right-content">{rightContent}</span>}
      {isAsync ? (
        <AsyncSelect
          {...rest}
          classNamePrefix={className || 'select-dropdown'}
          isDisabled={disabled}
          placeholder={placeholder}
          ref={selectRef}
          defaultOptions={defaultOptions}
          loadOptions={loadOptions}
          components={{ DropdownIndicator }}
        />
      ) : (
        <ReactSelect
          {...rest}
          classNamePrefix={className || 'select-dropdown'}
          isDisabled={disabled}
          placeholder={placeholder}
          ref={selectRef}
          options={listOptions}
          components={{ DropdownIndicator }}
        />
      )}
      {formInput && (
        <div className="error-msg">
          <ErrorMessage name={name} />
        </div>
      )}
    </div>
  );
};

Select.propTypes = {
  wrapperClassName: PropTypes.string,
  className: PropTypes.string,
  formInput: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'none']),
  onChange: PropTypes.func.isRequired,
  kind: PropTypes.oneOf(['minimal', 'normal']),
  rightContent: PropTypes.node,
  options: PropTypes.arrayOf(PropTypes.any),
  sort: PropTypes.bool,
  selectRef: PropTypes.objectOf(PropTypes.any) || PropTypes.func,
  defaultOptions: PropTypes.arrayOf(PropTypes.any),
  loadOptions: PropTypes.func,
  isAsync: PropTypes.bool,
};

Select.defaultProps = {
  className: '',
  formInput: false,
  required: false,
  disabled: false,
  label: '',
  placeholder: 'Select',
  size: 'lg',
  kind: 'normal',
  rightContent: '',
  isMulti: false,
  wrapperClassName: '',
  sort: false,
  selectRef: null,
  options: [],
  defaultOptions: [],
  loadOptions: () => {},
  isAsync: false,
};

export default Select;
